module.exports = __webpack_public_path__ + "img/004-sunset.ddf77757.svg";